<template>
	<!-- main wrapper -->
	<div id="lesson-content" class="tw-flex tw-flex-col tw-flex-1">
		<template v-if="course && lesson && sidebarLesson && module">
			<!-- highlighted content -->
			<div class="tw-flex highlighted-content-wrapper"
				v-if="(lesson.content_kind === 'video' || lesson.content_kind === 'audio') && (highlighted_iframe !== '' || highlightedVideo !== null)">
				<div class="content tw-flex tw-flex-1 tw-items-center">
					<template v-if="lesson.content_kind === 'video'">
						<div class="inner-content tw-w-full">
							<div class="responsive-video embed-16-by-9"
                                 v-if="highlightedVideo !== null">
                                <template v-if="highlightedVideo.source.type === 'file'">
									<VimeoVideo v-if="highlightedVideo.status === 'uploaded'"
										:id="highlightedVideo.source.content_id"></VimeoVideo>
									<div v-else
										class="video-processing-wrapper tw-absolute tw-top-0 tw-left-0 tw-rounded tw-w-full tw-h-full">
										<div
											class="tw-w-full tw-h-full tw-flex tw-flex-col tw-items-center tw-justify-center">
											<div class="tw-px-4 text-center tw-text-white md:tw-px-0 ">
												<i class="fal fa-clock tw-mb-3 tw-text-5xl md:tw-text-6xl"></i>
												<p class="md:tw-text-lg" v-text="$t('membership.processing_video')"></p>
											</div>
										</div>
									</div>
								</template>
                                <div v-else-if="highlightedVideo.source.type === 'embedded'"
                                     v-html="highlightedMediaIframe"></div>
							</div>
							<h1 v-else-if="$user.isAdmin"
								class="tw-text-red-600 tw-text-2xl tw-flex-1 tw-text-center tw-font-bold"
								>{{ $t('membership.no_highlighted_video') }}<br/><span class="!tw-text-base">({{ $t('community.only_visible_to_admins') }})</span></h1>
						</div>
					</template>
					<template v-else>
						<div class="inner-content tw-w-full" v-html="highlighted_iframe"
							v-if="highlighted_iframe && highlighted_iframe !== '' && isIframe(highlighted_iframe)">
						</div>
						<h1 v-else-if="$user.isAdmin"
							class="tw-text-red-600 tw-text-2xl tw-flex-1 tw-text-center tw-font-bold"
							v-text="$t('membership.no_highlighted_audio')"></h1>
					</template>
				</div>
			</div>

			<div class="page-content"
				:class="{ 'no-highlighted-content': highlighted_iframe === '' || (lesson.content_kind !== 'video' && lesson.content_kind !== 'audio') }">

				<!-- lesson meta info -->
				<div class="content-meta">
					<div class="content-meta-inner" v-if="course">
						<div class="course-image">
							<img :src="course.image ? course.image.url : '/img/image.resized.jpg?width=600'" onerror="this.src='/img/image.resized.jpg?width=600'">
						</div>
						<div class="content-header">
							<div class="tw-flex">
								<h1 v-text="lesson.name"
									class="tw-text-gray-800 tw-text-2xl tw-mb-2 tw-font-bold tw-leading-snug tw-flex-1">
								</h1>
								<div class="tw-flex">
									<!-- edit button -->
									<a v-if="$user.isAdmin" target="_blank"
										:href="'/admin/v2/e-learning/courses/' + course.id + '/modules/' + module.id + '/content/' + lesson.id + '/edit'">
										<i
											class=" far fa-pencil tw-items-center tw-justify-center tw-bg-gray-0 tw-rounded-full tw-text-gray-600 tw-simple-hover tw-select-none tw-mr-3"></i>
									</a>
									<!-- full screen toggle button -->
									<i class="full-w-switch-btn far fa-expand-wide tw-items-center tw-justify-center tw-bg-gray-0 tw-rounded-full tw-text-gray-600 tw-simple-hover tw-select-none"
										:class="{ 'secondary-c-bg secondary-c-contrast': full_screen }"
										@click="toggleFullScreen"></i>
									<i class="sidebar-menu-toggle-btn far fa-bars tw-items-center tw-justify-center tw-bg-gray-0 tw-rounded-full tw-text-gray-600 tw-simple-hover tw-select-none"
										@click="toggleFullScreen"></i>
								</div>
							</div>
							<h2 class="tw-text-gray-300" v-if="module">
								<template v-if="course.numbered">
									{{ $t('membership.module') }} {{ moduleIndex + 1 }} -
								</template>
								{{ module.name }}
							</h2>
						</div>
					</div>
				</div>



				<!-- main content -->
				<div class="page-content-inner" v-if="sidebarLesson.availability.available">
					<div class="lesson-content-wrapper" :class="{ 'no-content': lesson.content_kind === 'quiz' }">
						<template v-if="lesson.content_kind !== 'quiz'">
							<!-- uploads -->
							<div class="attachments tw-mb-8 tw-text-gray-300" v-if="attachments.length > 0">
								<h4 class="tw-text-gray-700 tw-font-semibold tw-text-xl tw-pb-4">{{
										$t('membership.attachments')
								}} ({{ attachments.length }})</h4>
								<SmoothReflow>
									<div class="attachment tw-inline-flex tw-items-center !tw-p-2 tw-rounded tw-simple-hover"
										v-for="attachment in visibleAttachments" :key="attachment.id">
										<a :href="attachment.url ? attachment.url : '/uploads/membership/' + attachment.name"
											target="_blank">
											<i class="far fa-paperclip tw-pr-2"></i>
											<span v-text="attachment.name"></span>
										</a>
									</div>
								</SmoothReflow>
								<div v-if="attachments.length > 3"
									class="tw-flex tw-items-center tw-text-gray-300 tw-simple-hover tw-mt-3 tw-pl-px tw-ml-px"
									@click="display_uploads = !display_uploads">
									<i class="far fa-angle-double-down tw-pr-2"
										:class="display_uploads ? 'fa-angle-double-up' : 'fa-angle-double-down'"></i>
									<span
										v-text="display_uploads ? $t('membership.show_less_attachments') : $t('membership.show_more_attachments')"></span>
								</div>
							</div>

							<!-- content -->
							<div class="lesson-content" v-if="!hideContent" v-html="lessonContent"></div>

							<div class="content-footer tw-bg-gray-0 tw-rounded-lg tw-p-6"
								:class="{ 'tw-mt-6': !hideContent }" v-if="hasFooter">
								<p v-if="lesson.footer.title" v-text="lesson.footer.title"></p>
								<a v-if="hasFooterLink" :href="lesson.footer.button_link" target="_blank" class="tw-simple-hover">
									<i class="fa fa-angle-double-right tw-pr-2"></i>
									{{ footerLinkTitle }}
								</a>
							</div>

                            <lesson-navigation v-if="lesson.content_kind !== 'quiz' && course && !course.manual_finish"
                                               class="tw-flex tw-justify-between"
                                               :class="hideContent && !hasFooter ? 'tw-mt-3' : 'tw-mt-6'"
                                               :lesson="lesson"
                                               :module="module"
                                               :course="course">
                            </lesson-navigation>

						</template>
					</div>

					<quiz v-if="lesson.content_kind === 'quiz' && lesson.quiz !== null" :quiz_id="lesson.quiz.id"
						:course_id="course.id" :key="lesson.quiz.id"></quiz>
				</div>

				<lesson-unavailable-box v-else>
					<h2>
						<i class="fa fa-lock"></i>
						{{ $t('membership.no_access_yet') }}
					</h2>
					<p
						v-if="module && ((((module.available && lessonUnlocksAt === null) || module.available_from !== null)) || lessonNotAvailableByNewDripping)">
						{{ $t('general.this') }}
						{{ $t('membership.lesson').toLowerCase() }}
						{{ $t('membership.available_at') }}
						<template v-if="lessonNotAvailableByNewDripping">
							{{ lessonUnlocksAt }}
						</template>
					</p>
					<a class="button general-button btn-v2 tw-bg-white tw-z-10 tw-mt-2" v-else-if="salespageUrl !== '#'"
						:href="salespageUrl" target="_blank" style="text-decoration: none;">
						{{ $t('membership.get_access_soft') }}
					</a>
				</lesson-unavailable-box>
			</div>

            <lesson-navigation v-if="lesson.content_kind === 'quiz' && course && !course.manual_finish"
                               :lesson="lesson"
                               :course="course"
                               :module="module"
                               :buttonColor="'tw-bg-gray-300'" class="tw-flex tw-justify-between tw-mx-auto tw-mb-20"
                               :style="{ width: '750px' }"></lesson-navigation>

			<!-- mark as finished -->
			<div class="finished-wrapper tw-flex tw-mx-auto tw-mb-20"
				v-if="$user && course && sidebarLesson.availability.available && course.manual_finish && $settings('membership.show_progress') == '1'"
				:class="{ 'finished': lesson_finished }">
                <LessonNavigationButton class="tw-flex tw-justify-center tw-items-center tw-text-gray-300 tw-text-4xl hover:tw-text-gray-600" direction="previous" :lesson="lesson" :module="module" :course="course">
                    <i class="content-nav-btn far fa-angle-left"></i>
                </LessonNavigationButton>
				<div class="mark-finished tw-flex-1 tw-flex tw-rounded-lg tw-items-center tw-p-3">
					<div class="finished-content tw-flex tw-flex-col tw-flex-1">
						<div class="tw-flex tw-mb-3 tw-text-gray-700 tw-items-center">
							<i class="fa fa-graduation-cap tw-text-3xl tw-mr-2"></i>
							<h4 class="tw-text-2xl tw-font-bold"
								v-text="lesson_finished ? $t('membership.lesson') + ' ' + $t('membership.course_finished') + '!' : $t('membership.lesson') + ' ' + $t('membership.course_finished') + '?'">
							</h4>
						</div>
						<p class="tw-text-gray-500 tw-text-base"
							v-text="lesson_finished ? $t('membership.mark_as_unfinished') : $t('membership.mark_as_finished')">
						</p>
					</div>
					<div class="finish-btn-wrapper tw-ml-2 tw-opacity-50 hover:tw-opacity-100"
						:class="{ 'tw-opacity-100': lesson_finished }" @click="complete">
						<div
							class="finish-btn tw-rounded-full tw-flex tw-items-center tw-justify-center tw-bg-white tw-text-2xl tw-text-gray-400 tw-cursor-pointer">
							<i class="fa fa-check"></i>
						</div>
					</div>
				</div>
                <LessonNavigationButton class="finished-nav-btn-wrapper tw-flex tw-justify-center tw-items-center tw-text-gray-300 tw-text-4xl hover:tw-text-gray-600" :class="{ 'tw-text-gray-500 hover:tw-text-gray-700': lesson_finished }" direction="next" :lesson="lesson" :module="module" :course="course">
                    <i class="content-nav-btn far fa-angle-right"></i>
                </LessonNavigationButton>
			</div>
		</template>
		<template v-else-if="lesson_loading_error || lesson_invalid_access">
			<div class="page-content no-highlighted-content">
				<lesson-unavailable-box>
					<template v-if="$user">
						<h2>
							<i class="fa fa-exclamation-triangle"></i>
							{{ lesson_invalid_access ? $t('membership.no_access_yet') : $t('membership.page_could_not_be_loaded') }}
						</h2>
						<p>{{ lesson_invalid_access ?  $t('membership.no_access_yet_desc') : $t('membership.try_again_later_contact_administrator') }}</p>
					</template>
					<template v-else>
						<h2>
							<i class="fa fa-user"></i>
							{{ $t('login.not_yet_logged_in') }}
						</h2>
						<p>{{ $t('membership.login_to_access_caption') }}</p>
						<a class="button general-button btn-v2 tw-bg-white tw-z-10 tw-mt-2" href="/login"
							style="text-decoration: none;">
							{{ $t('login.login_or_register') }}
						</a>
					</template>
				</lesson-unavailable-box>
			</div>
		</template>
		<template v-else>
			<!-- skeleton -->
			<div class="page-content no-highlighted-content">
				<div class="content-meta">
					<div class="content-meta-inner">
						<div class="course-image tw-bg-gray-100"></div>
						<div class="content-header">
							<div class="tw-rounded tw-bg-gray-100 tw-mb-2" style="height: 32px; width: 55%;"></div>
							<div class="tw-rounded tw-bg-gray-0" style="height: 16px; width: 35%;"></div>
						</div>
					</div>
				</div>
				<div class="page-content-inner">
					<div class="lesson-content-wrapper">
						<div class="lesson-content tw-flex tw-flex-col">
							<div class="lesson-skeleton-content-paragraph">
								<div class="lesson-skeleton-content-line" style="width: 100%;"></div>
								<div class="lesson-skeleton-content-line" style="width: 80%;"></div>
								<div class="lesson-skeleton-content-line" style="width: 60%;"></div>
							</div>

							<div class="lesson-skeleton-content-paragraph">
								<div class="lesson-skeleton-content-line" style="width: 90%;"></div>
								<div class="lesson-skeleton-content-line" style="width: 15%;"></div>
							</div>

							<div class="lesson-skeleton-content-paragraph">
								<div class="lesson-skeleton-content-line" style="width: 45%;"></div>
								<div class="lesson-skeleton-content-line" style="width: 60%;"></div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</template>
	</div>
</template>

<script>
import { mapState } from 'vuex';
import Global from '../../mixins/Global';
import Moment from '../../mixins/Moment';
import Course from '../../mixins/v2/Course'
import VimeoVideoMixin from '../../mixins/v2/VimeoVideoMixin';
import LessonNavigation from '../../components/e-learning/LessonNavigation'
import LessonUnavailableBox from "../../components/e-learning/LessonUnavailableBox.vue";
import VimeoVideo from "../../components/VimeoVideo";
import LessonNavigationButton from "@/resources/assets/js/vue/components/e-learning/LessonNavigationButton.vue";

export default {
	name: 'Content',

	components: {
        LessonNavigationButton,
		VimeoVideo,
		LessonUnavailableBox,
		LessonNavigation,
	},

	mixins: [Global, VimeoVideoMixin, Moment, Course],

	props: {
		course: {
			required: true,
		},
		full_screen: {
			required: true,
		},
	},

	data() {
		return {
			envoyer_release_id,
			sidebar_edit_data_loaded: false,
			display_uploads: false,
			lesson_loading_error: false,
			lesson_invalid_access: false,
			async_scripts: [],
			blocking_scripts: [],
			vimeo_players: [],
			lesson_id: null,
            attachments: [],
            videos_loaded: false,
            videos: [],
            scripts: [],
		}
	},

	computed: {
		...mapState('quiz', ['quiz', 'passed_quiz', 'quizSettings']),

		lesson() {
			return LessonV4.query().where('id', this.lesson_id).first();
		},
        
        sidebarLesson() {
            return this.module.lessons.find((lesson) => lesson.id === this.lesson_id);
        },

        lessonUnlocksAt() {
            if (this.sidebarLesson.availability.available_from === null) {
                return null;
            }

            return moment(this.sidebarLesson.availability.available_from).format("DD-MM-YYYY HH:mm");
        },

        hasFooter() {
            if (!this.lesson.footer || !this.lesson.footer.enabled) {
                return false;
            }

            const { button_link, title } = this.lesson.footer;

            return (button_link != null && button_link !== "") || (title != null && title !== "");
        },

        hasFooterLink() {
            return this.lesson.footer.button_link != null;
        },

        footerLinkTitle() {
            const { button_link, button_text } = this.lesson.footer;

            return button_text != null && button_text != "" ? button_text : button_link;
        },

		lesson_finished() {
			return this.lesson && this.lesson.seen;
		},

		hasHighlightedContent() {
			return (this.lesson.content_kind === 'video' || this.lesson.content_kind === 'audio') && (this.highlighted_iframe !== '' || this.highlightedVideo !== null);
		},

		highlighted_iframe() {
			return this.lesson.highlighted_content;
		},

		highlightedMediaIframe() {
            if (this.highlightedVideo && this.highlightedVideo.source.type === 'embedded') {
				if (this.highlightedVideo.source.content === null) {
					if (this.highlightedVideo.source.host === 'vimeo') {
            const sourceContentIdContainsQuestionMark = this.highlightedVideo.source.content_id.includes('?');
						return `<iframe src="https://player.vimeo.com/video/${this.highlightedVideo.source.content_id}${sourceContentIdContainsQuestionMark ? '&' : '?'}color=33718a&title=0&byline=0&portrait=0" frameborder="0" allowfullscreen></iframe>`;
					}

					if (this.highlightedVideo.source.host === 'youtube') {
						return `<iframe src="https://www.youtube.com/embed/${this.highlightedVideo.source.content_id}" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>`;
					}
				}

				return this.highlightedVideo.source.content;
			}

			return this.lesson.highlighted_content;
		},

		visibleAttachments() {
			if (this.display_uploads) {
				return this.attachments;
			}

			return this.attachments.slice(0, 3);
		},

		lessonContent() {
			const self = this;

			return this.lesson.content?.replaceAll(/>https:\/\/link\.thehuddle.nl\/.*?\//gmi, function (url) {
				// if the link goes to the homepage, i.e. https://huddle.local, the first / found by the regex will be of </a>
				// we don't want to replace the '</' portion of this as it will break the link
				// so in that case we add '</' to the end to keep it from breaking
				if (url.slice(-2) === '</') {
					return '>' + self.$settings('domain') + '/</';
				}

				return '>' + self.$settings('domain') + '/';
			});
		},

		module() {
			return this.course.modules.find(module => module.slug === this.$route.params.module_slug);
		},

		modules() {
			return this.course.modules.filter((module) => !module.no_dashboard || module.lessons.length > 0);
		},

		moduleIndex() {
            return this.modules.findIndex(module => module.id === this.module.id);
		},

		highlightedVideo() {
			return [...this.videos].reverse().find(media => media.type === 'highlighted') ?? null;
		},

		salespageUrl() {
			if (!this.user && (this.course.sales_page === '' || this.course.sales_page === null) && (this.module.sales_page === '' || this.module.sales_page === null)) {
				return '/auth/login#login';
			} else {
				if (!this.module.available && this.module.sales_page !== '' && this.module.sales_page !== null) {
					return this.module.sales_page ?? '#';
				} else if (this.course.sales_page !== '' && this.course.sales_page !== null) {
					return this.course.sales_page ?? '#';
				}

				return '#';
			}
		},

		hideContent() {
			if (this.lesson.content_kind === 'text' || this.lesson.content_kind === 'quiz') {
				return false;
			}

			return this.hasHighlightedContent && (this.lesson.content === '' || this.lesson.content === 'content' || this.lesson.content === '-' || this.lesson.content === '<p>content</p>')
		},

        lessonNotAvailableByNewDripping() {
            return !this.sidebarLesson.availability.available && this.lessonUnlocksAt !== null;
        },

        allDataLoaded() {
            return this.course && this.lesson && this.sidebarLesson && this.module && this.videos_loaded;
        },
	},

	mounted() {
		this.getLesson();
        this.getAttachments();
        this.getVideos();
        this.getScripts();
	},

	methods: {
        updateStoredCourseProgress(seen) {
            this.lesson.seen = seen;
            this.sidebarLesson.seen = seen;
        },

		getLesson() {
			// get this lesson
			LessonV4.api().fetchById(this.$route.params).then((lessonData) => {
                this.lesson_id = lessonData.id;
				document.title = this.lesson.name;

				if (this.lesson.content_kind === 'quiz' && this.lesson.quiz) {
					this.$store.dispatch('quiz/getQuiz', this.lesson.quiz.id);
				}

				this.setupCustomScripts();
			}).catch((error) => {
				if(error.response.status === 403) {
					this.lesson_invalid_access = true;
				} else {
					this.lesson_loading_error = true;
				}
			});
		},

        getAttachments() {
            const { course_slug, module_slug, lesson_slug } = this.$route.params;

            axios.get(`/api/v4/e-learning/courses/${course_slug}/modules/${module_slug}/lessons/${lesson_slug}/attachments?per_page=500`).then((response) => {
                this.attachments = response.data.data;
            });
        },

        getVideos() {
            const { course_slug, module_slug, lesson_slug } = this.$route.params;
            this.videos_loaded = false;

            axios.get(`/api/v4/e-learning/courses/${course_slug}/modules/${module_slug}/lessons/${lesson_slug}/videos?per_page=500`).then((response) => {
                this.videos = response.data.data;
                this.videos_loaded = true;
            }).catch(() => {
                this.videos_loaded = true;
            });
        },

        getScripts() {
            const { course_slug, module_slug, lesson_slug } = this.$route.params;

            axios.get(`/api/v3/e-learning/courses/${course_slug}/modules/${module_slug}/lessons/${lesson_slug}/scripts`).then((response) => {
                this.scripts = response.data.data;
                this.setupCustomScripts();
            });
        },

		complete() {
			LessonV4.api().complete(this.$route.params, !this.lesson.seen).then(() => {
                this.updateStoredCourseProgress(!this.lesson.seen);
			});
		},

		isIframe(code) {
			let regex = /<iframe(.+)<\/iframe>/g;

			return code.match(regex);
		},

		convertShortcodeIntoVideo() {
			if (this.videos !== null && this.videos.length > 0) {
				this.videos.forEach((video) => {
					if (video.type === 'normal') {
						let media_element;
						const uuid = Math.floor(Math.random() * 999999);

						if (typeof video !== 'undefined') {
							if (video.source.type === 'file') {
								if (video.status === 'uploaded') {
									media_element = `<div id="vimeo-player-${uuid}${video.source.content_id}"></div>`;
								} else {
									media_element = `<div class="video-processing-wrapper tw-absolute tw-top-0 tw-left-0 tw-w-full tw-h-full"><div class="tw-w-full tw-h-full tw-flex tw-flex-col tw-items-center tw-justify-center"><i class="fal fa-clock tw-text-gray-300 tw-mb-3 tw-text-5xl md:tw-text-6xl"></i>${this.$t('membership.processing_video')}</div></div>`;
								}
							} else if (video.source.type === 'embedded') {
								if (video.source.content === null) {
									if (video.source.host === 'vimeo') {
                    const sourceContentIdContainsQuestionMark = video.source.content_id.includes('?');
										media_element = `<iframe src="https://player.vimeo.com/video/${video.source.content_id}${sourceContentIdContainsQuestionMark ? '&' : '?'}color=33718a&title=0&byline=0&portrait=0" frameborder="0" allow="fullscreen" allowfullscreen></iframe>`;
									} else if (video.source.host === 'youtube') {
										media_element = `<iframe src="https://youtube.com/embed/${video.source.content_id}" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>`;
									}
								} else {
									media_element = video.source.content;
								}
							}

							this.lesson.content = this.lesson.content.replace(`<span data-huddle-media-item="true" hidden="true">[media_id=${video.id}:pivot_id=${video.media_id}]</span>`, `<div class="responsive-video embed-16-by-9 no-margin-top">${media_element}</div>`);

							if (video.source.type === 'file' && video.status === 'uploaded') {
								this.$nextTick(() => {
									this.vimeo_players.push(
										this.initializeVimeoVideo(uuid, video.source.content_id)
									);
								});
							}
						}
					}
				});
			}
		},

		toggleFullScreen() {
			this.$emit('toggleFullScreen');
		},

		setupCustomScripts() {
			// remove all existing scripts from previously active lessons
			const loadedScripts = document.getElementsByClassName('lesson-custom-script');

			while (loadedScripts.length > 0) {
				loadedScripts[0].parentNode.removeChild(loadedScripts[0]);
			}

			// loop through all lesson scripts
			for (let i = 0; i < this.scripts.length; i += 1) {
				// create a template
				const template = document.createElement('template')

				// set the HTML of the template to the trimmed script
				template.innerHTML = this.scripts[i].script.trim();

				// loop through all generated nodes
				for (let i = 0; i < template.content.childNodes.length; i += 1) {
					const script_node = template.content.childNodes[i];

					// only load script and style elements
					if (['SCRIPT', 'STYLE'].includes(script_node.nodeName)) {
						// create a new dom element
						const script = document.createElement(script_node.nodeName.toLowerCase());
						script.className = 'lesson-custom-script';

						// if it's a style element or a script that has content
						if (script_node.nodeName === 'STYLE' || script_node.innerHTML.length > 0) {
							script.appendChild(document.createTextNode(script_node.innerHTML));

							// add to the async scripts array
							this.async_scripts.push(script);
						} else {
							// it's a script without content, which means it's a <script src=""> element
							for (let i = 0; i < script_node.attributes.length; i += 1) {
								// find the src attribute
								if (script_node.attributes[i].nodeName === 'src') {
									// set the src on the script
									script.src = script_node.attributes[i].value;

									// add to the scripts array
									this.blocking_scripts.push(script);
								}
							}
						}
					}
				}
			}

			if (this.blocking_scripts.length === 0) {
				// if we don't have any scripts that need to be loaded, start loading async scripts
				this.loadAsyncScripts();
			} else {
				// start loading first blocking script
				this.loadBlockingScript(0);
			}
		},

		// loop over async scripts and load them
		loadAsyncScripts() {
			for (let i = 0; i < this.async_scripts.length; i += 1) {
				document.body.appendChild(this.async_scripts[i]);
			}
		},

		// loop over a blocking script and load it before loading the next one
		loadBlockingScript(index) {
			document.body.appendChild(this.blocking_scripts[index]);

			// listen to load event
			this.blocking_scripts[index].addEventListener('load', () => {
				// if there are more blocking scripts, load the next one
				if (this.blocking_scripts.length > (index + 1)) {
					this.loadBlockingScript(index + 1);
				} else {
					// if there aren't any more blocking scripts left, load the async ones
					this.loadAsyncScripts();
				}
			});
		},
	},

	watch: {
        allDataLoaded(loaded) {
			if (loaded) {
				if (!this.course.manual_finish && this.sidebarLesson.availability.available) {
                    this.updateStoredCourseProgress(true);
				}

                if (this.lesson.content_kind !== 'quiz') {
                    this.$nextTick(() => {
                        $(".lesson-content").find($("iframe")).each(function () {
                            const src = $(this)[0].src;

                            if ((src.indexOf('youtu') > 0 || src.indexOf('vimeo') > 0) && !$(this).parent().hasClass('responsive-video')) {
                                $(this).wrap('<div class="responsive-video embed-16-by-9"></div>');
                            }
                        });

                        $(".lesson-content").find($("img")).each(function () {
                            $(this).wrap('<div class="worksheet-image"></div>');
                        });

                        $(".lesson-content :first-child").first().addClass('no-margin-top');

                        $(".lesson-content").children().last().addClass('no-margin-bottom');
                    });

                    this.convertShortcodeIntoVideo();
                }
			}
		},
	},
}
</script>

<style lang="scss">
#lesson-content {
	.edit-btn {
		left: 16px;
		top: 88px;
		background: #2980b9;
		opacity: 0.9;
		width: 48px;
		height: 48px;
		font-size: 24px;
	}

	.highlighted-content-wrapper {
		background: #191717;
		padding-top: 25px;
		padding-bottom: 25px;

		.content {
			max-width: 750px;
			margin: auto;
			border-radius: 5px;

			.inner-content {
				// if this is needed, check with jelle as this is removed for the video library
				/*:not(iframe):not(h1):not(video) {
					display: none;
				}*/

				.responsive-video {
					display: block;
					box-shadow: 0 2px 4px 2px rgba(0, 0, 0, 0.1);
					border-radius: 5px;

					// if this is needed, check with jelle as this is removed for the video library
					/*:not(iframe):not(h1):not(video):not(div.video-processing-wrapper):not(div.highlighted-iframe-wrapper) {
						display: none;
					}*/

					.video-processing-wrapper {
						background: #37474F;
					}
				}
			}

			iframe {
				border-radius: 5px;
			}

			@media(max-width: 1170px) {
				max-width: 650px;
			}

			@media(max-width: 767px) {
				max-width: 100%;
			}
		}

		@media(max-width: 767px) {
			@apply tw-p-5;
			margin-top: 64px;
		}
	}

	.quiz-content-wrapper {
		margin-top: 70px;
	}

	.page-content {
		@apply tw-bg-white tw-flex tw-flex-col tw-rounded tw-mx-auto;
		width: 750px;
		margin-top: 25px;
		margin-bottom: 25px;
		box-shadow: 0px 8px 4px -3px #e2e5ea;

		.content-meta {
			@apply tw-border-b-2 tw-border-gray-0 tw-m-7 tw-pb-8;
			min-height: 105px;

			.content-meta-inner {
				@apply tw-flex tw-items-center;

				.course-image {
					@apply tw-mr-5 tw-rounded-full tw-overflow-hidden;
					width: 75px;
					height: 75px;

					img {
						@apply tw-object-cover;
						width: 75px;
						height: 75px;
					}
				}
			}

			@screen md {
				@apply tw-m-14 tw-mb-0;
			}
		}

		.page-content-inner {
			@apply tw-flex-1 tw-mb-6;

			@screen md {
				@apply tw-mb-0;
			}
		}

		.content-header {
			@apply tw-flex-1;

			i {
				display: flex !important;
				width: 30px;
				height: 30px;

				&.full-w-switch-btn {
					@media(max-width: 1100px) {
						display: none !important;
					}
				}

				&.sidebar-menu-toggle-btn {
					display: none !important;

					@media(max-width: 1100px) {
						display: flex !important;
					}
				}
			}

			h1 {
				@apply tw-text-2xl tw-mb-0 tw-font-bold #{!important};
			}

			h2 {
				@apply tw-mb-0 #{!important};
			}
		}

		.lesson-content-wrapper {
			@apply tw-p-7 tw-pt-0;

			.responsive-video {
				@apply tw-mt-4 tw-mb-7;

				iframe,
				video {
					border-radius: 5px;
				}

				.video-processing-wrapper {
					background: #FAFAFA;
				}
			}

			.worksheet-image {
				text-align: center;

				img {
					@apply tw-max-w-full tw-h-auto;
					margin-top: 0.5rem !important;
					margin-bottom: 1.25rem !important;

					&.fr-rounded {
						border-radius: 5px;
					}
				}
			}

			h2 {
				@apply tw-leading-relaxed #{!important};
				margin-top: 2rem !important;
				margin-bottom: 1.25rem !important;
				font-size: 1.5rem !important;
				font-weight: 700 !important;
				color: #2d3748 !important;
			}

			h3 {
				@apply tw-leading-relaxed #{!important};
				margin-top: 1.5rem !important;
				margin-bottom: 0.75rem !important;
				color: #2d3748 !important;
				font-weight: 600 !important;
				font-size: 1.25rem !important;
			}

			p {
				font-size: 15px !important;
				line-height: 2 !important;
				color: #676767 !important;
				margin-bottom: 0.75rem !important;
				margin-top: 0 !important;

				a {
					font-size: inherit !important;
				}

				@media(max-width: 767px) {
					font-size: 14px !important;
				}
			}

			ul {
				@apply tw-list-disc;

				li {
					font-size: 15px !important;

					a {
						font-size: inherit !important;
					}

					@media(max-width: 767px) {
						font-size: 14px !important;
					}
				}
			}

			ol {
				@apply tw-list-decimal;

				li {
					font-size: 15px !important;

					a {
						font-size: inherit !important;
					}

					@media(max-width: 767px) {
						font-size: 14px !important;
					}
				}
			}

			blockquote {
				@apply tw-mb-4 tw-mt-6;
			}

			ol,
			ul {
				@apply tw-mb-3 tw-ml-3;
				padding-left: 0.7rem;

				li {
					@apply tw-pl-3 tw-leading-loose tw-text-gray-500 tw-text-lg;
					color: #6b6b6b;
				}
			}

			pre {
				@apply tw-whitespace-pre-wrap;
				font-size: 15px !important;

				@media(max-width: 767px) {
					font-size: 14px !important;
				}
			}

			.text-center {
				@apply tw-text-center;
			}

			.text-left {
				@apply tw-text-left;
			}

			.text-right {
				@apply tw-text-right;
			}

			a {
				@apply tw-text-lg tw-font-semibold tw-underline;
				color: #37b6f5;

				&:hover {
					opacity: 0.8;
				}
			}

			table {
				@apply tw-w-full tw-my-4;

				tbody {
					tr {
						td {
							@apply tw-py-1 tw-px-2 tw-text-lg tw-text-gray-600;
							border: 1px solid #bdbdbd;
							font-weight: 400;
						}
					}
				}

				thead {
					@apply tw-p-2;

					tr {
						th {
							@apply tw-py-1 tw-px-3 tw-text-lg tw-text-gray-600;
							background: #ececec;
							width: 33.33333%;
							border: 1px solid #bdbdbd;
						}
					}
				}

				&.fr-alternate-rows {
					tbody {
						tr:nth-child(2n) {
							background: whitesmoke;
						}
					}
				}
			}

			.no-margin-top {
				margin-top: 0 !important;

				* {
					margin-top: 0 !important;
				}
			}

			.no-margin-bottom {
				margin-bottom: 0 !important;

				* {
					margin-bottom: 0 !important;
				}
			}

			.attachment {
				a {
					color: #9e9e9e;
					font-weight: 400;
					text-decoration: none;
					font-size: 1rem;
				}

				&:last-of-type {
					padding-bottom: 0;
				}
			}

			@screen md {
				@apply tw-p-14 tw-pt-8 tw-pb-8;
			}

			&.no-content {
				@apply tw-p-0;
			}
		}

		.content-footer {
			p {
				@apply tw-mb-3 tw-text-gray-800 #{!important};
			}

			a {
				@apply tw-no-underline tw-font-black #{!important};
			}
		}

		&.no-highlighted-content {
			margin-top: 95px;
		}

		@media(max-width: 1170px) {
			width: 650px;
		}

		@media(max-width: 1100px) {
			margin-top: 12px;
			border-radius: 0;
			width: 100%;

			&.no-highlighted-content {
				margin-top: 64px;
			}
		}
	}

	.finished-wrapper {
		width: 750px;

		a {
			//width: 10%;
			width: 8%;
		}

		.mark-finished {
			transition: background-color 0.15s ease;

			.finish-btn-wrapper {
				transition: border 0.15s ease;
				border-radius: 100%;
				padding: 2px;
				border: 2px solid transparent;

				.finish-btn {
					transition: transform 0.15s ease, color 0.15s ease;
					width: 55px;
					height: 55px;
					box-shadow: 0 2px 4px 3px rgba(0, 0, 0, 0.05);

					&:hover {
						transform: scale(1.15);
					}
				}
			}
		}

		.finished-nav-btn-wrapper {
			transition: width 0.2s, font-size 0.2s, opacity 0.2s;
		}

		&.finished {
			.mark-finished {
				.finish-btn-wrapper {
					.finish-btn {
						@apply tw-bg-green-500 tw-text-white;
					}
				}
			}

			.finished-nav-btn-wrapper {
				width: 12%;
				font-size: 4rem;
				opacity: 1;
			}
		}

		@media(max-width: 1170px) {
			width: 650px;
		}

		@media(max-width: 1100px) {
			width: 98%;

			a {
				width: 10%;
			}

			.mark-finished {
				@apply tw-p-5;

				.finished-content {
					i {
						@apply tw-text-2xl;
					}

					h4 {
						@apply tw-text-xl;
					}

					p {
						@apply tw-leading-relaxed;
					}
				}

				.finish-btn-wrapper {
					.finish-btn {
						@apply tw-text-2xl;
						width: 50px;
						height: 50px;
					}
				}
			}

			&.finished {
				.finished-nav-btn-wrapper {
					font-size: 3.25rem;
				}
			}
		}
	}

	.lesson-skeleton-content-paragraph {
		@apply tw-mb-4;

		.lesson-skeleton-content-line {
			@apply tw-rounded tw-bg-gray-100 tw-mb-2;
			height: 16px;
		}
	}
}
</style>
